module.exports = __webpack_public_path__ + "static/lego-bricks-17d3757f7306c1cafbe21731b80ab24c.png";